import { createFileRoute, redirect } from '@tanstack/react-router';
import { Box } from 'components/Box';
import Icon from 'components/Icon/Icon.component';
import greenCheckCircle from 'images/icons/green_check_circle.svg';
import { Translate } from 'react-localize-redux';
import { Text } from 'style/text.style';

export const Route = createFileRoute('/_auth/safe-gaming-success')({
  beforeLoad: () => {
    if (window.AR_APP_COUNTRY !== 'es') throw redirect({ to: '/' });
  },
  component: SafeGamingSuccess,
});
function SafeGamingSuccess() {
  return (
    <>
      <Box
        display={'flex'}
        justifyContent={'center'}
        width={'100vw'}
        height={'100vh'}
        backgroundColor="#fff"
      >
        <Box
          maxWidth={604}
          width={'100%'}
          margin={'0 auto'}
          display={'flex'}
          padding={'48px 16px'}
          flexDirection={'column'}
          gap="24px"
        >
          <Box
            padding={16}
            border={'1px solid rgba(191, 191, 191, 1)'}
            borderRadius={8}
            display={'flex'}
            flexDirection={'column'}
          >
            <Icon
              margin="0 auto"
              iconSize={'56px'}
              height={'56px'}
              iconSrc={greenCheckCircle}
            />
            <Text textSize={'18px'} textWeight={600} margin={'24px 0 8px 0'}>
              <Translate id="lbl.sessionLimitsSet" />
            </Text>
            <Text textSize={'14px'}>
              <Translate id="lbl.sessionLimitsSetDescription" />
            </Text>
          </Box>
        </Box>
      </Box>
    </>
  );
}
